import React, { useState } from 'react';
import "../assets/css/home.css"
import OwnDetails from './ChildComp/OwnDetails';
import PetDetails from './ChildComp/PetDetails';
import OtherLink from '../components/ChildComp/OtherLink';
import google from "../assets/images/GoogleReview.webp";
import ratings from "../assets/images/ratings.svg";
const Home = () => {

    const [IsshowPetDetails, setIsshowPetDetails] = useState(false)
    const [IsShowOwnDetails, setIsShowOwnDetails] = useState(true)
    const [ownerName, setOwnerName] = useState("");
   
    const goback = () => {
        setIsShowOwnDetails(true);
        setIsshowPetDetails(false);
    }

    const gotoTop = () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    return (
        <div className="Home">
            <div className=" formSection">
                <section className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="petInsuranceSec1">
                                <h1><span className='Red'>{ownerName && <span>Hi <span className="Green CapitalizeName">{ownerName}</span>, </span> }</span> <span> Best </span> Pet Insurance Plans for your friend</h1>

                                <img src={require("../assets/images/homePet1.svg").default} alt="" className="Pet_homeImg" />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="pet_form">
                                {IsShowOwnDetails &&
                                    <OwnDetails ShowPdetails={setIsshowPetDetails} HideOwnDetails={setIsShowOwnDetails} setOwnerName={setOwnerName} />
                                }

                                {IsshowPetDetails &&
                                    <PetDetails goback={goback} />
                                }
                                <OtherLink />


                            </div>
                                <div className="review_box2">
                                    <a
                                        className="review_box"
                                        href="/customer-reviews"
                                        target="_blank"
                                    >
                                        <div className="indem-rate">
                                            <img src={google} className="indem_googl" />
                                            <img src={ratings} className="indem_star" />
                                        </div>
                                        <p>Highly rated insurance website</p>
                                    </a>
                                </div>
                        </div>
                    </div>
                </section>
                </div>
                <div className="container">
                <section className="petInsuranceSec2">
                    <div className="secInner">
                        <h3>Pet Insurance</h3>
                        <p>
                            Do you know why dogs are considered the most loyal pet? Because they are obliged to you for their well-being and get mixed up with human emotions quickly, they act as the protector for you. They show their affection through tail wagging, licking people, barking to call people, etc. Your dogs are so possessive of you. As you consider them your children, they too consider you as their guardian. Therefore, just like a family members, they too need insurance coverage to provide the best medical care against any unexpected veterinary expenses.
                        </p>
                    </div>
                    <div className="secInner">
                        <h3>Benefits of providing Pet Insurance {OwnDetails.IsShowOwnDetails}</h3>
                        <ul>
                            <li>
                                <img src={require("../assets/images/call.svg").default}  alt=""/>
                                <span>Doctor on call</span>
                            </li>
                            <li>
                                <img src={require("../assets/images/pet-minding.svg").default} alt="" />
                                <span>Emergency pet<br /> minding</span>
                            </li>
                            <li>
                                <img src={require("../assets/images/saves-money.svg").default}  alt=""/>
                                <span>Saves money</span>
                            </li>
                            <li>
                                <img src={require("../assets/images/pet-health.svg").default}  alt=""/>
                                <span>Allows to focus<br /> on pet health</span>
                            </li>
                            <li>
                                <img src={require("../assets/images/coverage.svg").default}  alt=""/>
                                <span>Coverage from the<br /> age of 6 months</span>
                            </li>
                            <li>
                                <img src={require("../assets/images/pet-hospital.svg").default}  alt=""/>
                                <span>Surgery and<br /> hospitalizations</span>
                            </li>
                        </ul>
                    </div>
                    <div className="secInner">
                        <h3>Who should purchase this policy?</h3>
                        <p>
                            This policy is beneficial for the person who owns a pet dog and wants coverage against various expenses that may be incurred during the treatment of their dog's illness or in case of hospitalization. By purchasing this policy, it will ensure peace of mind and satisfaction about their well-being.
                        </p>
                    </div>

                    </section>
                </div>

            <section className="petInsuranceSec3">
                <div className="container">
                    <div className="secInner">
                        <h3>Coverages</h3>
                        <p>
                            Pet Insurance comes with various coverages and add-ons which makes it more lucrative for pet owners to purchase the policy to provide extra protection to their affectionate dogs.
                        </p>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="CoveragesList">
                                    <p>Various coverages are as follows:</p>
                                    <ul>
                                        <li>Terminal illness coverage</li>
                                        <li>Surgery and hospitalization coverage</li>
                                        <li>Death coverage</li>
                                        <li>Funeral cost coverage</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="CoveragesList">
                                    <p>Various add-ons are as follows:</p>
                                    <ul>
                                        <li>Emergency pet-sitter Coverage</li>
                                        <li>Third-party liability cover</li>
                                        <li>Lost and stolen coverage</li>
                                        <li>Doctor consultancy</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <p>
                            Note: Coverage and add-ons can be purchased at the time of purchasing or renewal of the policy. It cannot be purchased in the mid of the policy.
                        </p>
                    </div>
                </div>
            </section>
            <section className="petInsuranceSec4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div>
                                <h3>Eligibility Criteria</h3>
                                <ul>
                                    <li>All types of dog breeds like small/ medium/ large/ giant breeds are covered under this policy.</li>
                                    <li>The type of dog covered under this policy is subject to its health condition according to veterinary doctors.</li>
                                </ul>
                            </div>
                            <div>
                                <h3>Pre-Requisite</h3>
                                <p>For insuring your pet dog, you need to submit the following documents to the insurance company</p>
                                <ul>
                                    <li>Registered document from Municipal Corporation or deemed local government authority or certified Kennel Club of India.</li>
                                    <li>Photographs of the dog from the front side, left side, right side, and specific birthmark if any.</li>
                                    <li>Self-declaration on vaccination conducted on time</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src={require("../assets/images/pet-activity.svg").default} alt="" className="pre_requiImg" />
                        </div>

                        <div className="col-md-12">
                            <h3>Sum Insured</h3>
                            <p>The sum insured amount depends on the health evaluation and prescription from the certified veterinary doctor.</p>
                            <p>So, now when you have read all the benefits, exclusions, coverages, and add-ons of pet insurance, what are you waiting for? A pet insurance policy is best suitable for your pampered dog which will provide overall protection coverage for them. So, avail the best policy today itself.</p>
                        </div>
                        <div className="col-md-4 offset-md-4 mt-4 insuranceNowBtn">
                            <button className="SMCBTN" id="quotesBtn" name="Member" onClick={()=>gotoTop()}>Get insurance for your pet now</button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
export default Home;
